import React from 'react';
import SurfaceCard from './SurfaceCard';
import {BoxProps} from 'components/ui/chakra';

interface BodyContainerProps extends BoxProps {
	children: React.ReactNode;
}

const BodyContainer = ({children, ...rest}: BodyContainerProps) => (
	<SurfaceCard w='auto' {...rest}>
		{children}
	</SurfaceCard>
);

export default BodyContainer;
